import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { useCart } from "../pages/js/CartContext";
import logo from "../images/Logo.jpg";
import "./Header.css";

function Header() {
  const { getTotalItems } = useCart();
  const totalItems = getTotalItems();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Empêcher le scroll quand le menu est ouvert
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMenuOpen]);

  return (
    <>
      <header className="App-header">
        <Link to="/">
          <img className="logo" src={logo} alt="Logo" />
        </Link>

        <button
          className={`hamburger ${isMenuOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className="desktop-nav">
          <ul>
            <li>
              <NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>Accueil</NavLink>
            </li>
            <li>
              <NavLink to="/boutique" className={({ isActive }) => isActive ? "active" : ""}>Boutique</NavLink>
            </li>
            <li>
              <NavLink to="/about" className={({ isActive }) => isActive ? "active" : ""}>À propos</NavLink>
            </li>
            <li>
              <NavLink to="/contact" className={({ isActive }) => isActive ? "active" : ""}>Contact</NavLink>
            </li>
            {/* <li>
              <Link to="/admin">Admin</Link>
            </li> */}
          </ul>
        </nav>
        <nav className="desktop-nav">
          <ul >
            <li>
              <a
                href="https://instagram.com/chantournagepatricia"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="bi bi-instagram"
              ></a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/chantournagepatricia"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="bi bi-facebook"
              ></a>
            </li>
            <li>
              <NavLink to="/panier" className={({ isActive }) => `cart-link bi bi-cart-fill ${isActive ? "active" : ""}`}>
                &nbsp; Panier
                {totalItems > 0 && (
                  <span className="cart-badge">{totalItems}</span>
                )}
              </NavLink>
            </li>
          </ul>
        </nav>
      </header>

      {/* Menu modal mobile */}
      {isMenuOpen && (
        <div className="menu-overlay" onClick={closeMenu}>
          <div className="menu-modal magicpatern5" onClick={(e) => e.stopPropagation()}>
            <div className="menu-header">
              <img src={logo} alt="Logo" className="menu-logo" />
              <button className="close-menu" onClick={closeMenu}>
                ✕
              </button>
            </div>
            <nav className="mobile-nav">
              <ul>
                <li>
                  <NavLink to="/" onClick={closeMenu} className={({ isActive }) => isActive ? "active" : ""}>
                    Accueil
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/boutique" onClick={closeMenu} className={({ isActive }) => isActive ? "active" : ""}>
                    Boutique
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/about" onClick={closeMenu} className={({ isActive }) => isActive ? "active" : ""}>
                    À propos
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/contact" onClick={closeMenu} className={({ isActive }) => isActive ? "active" : ""}>
                    Contact
                  </NavLink>
                </li>
                <li>
                  <a
                    href="https://instagram.com/chantournagepatricia"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    className="social-link"
                  >
                    <i className="bi bi-instagram"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://facebook.com/chantournagepatricia"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    className="social-link"
                  >
                    <i className="bi bi-facebook"></i>
                  </a>
                </li>
                <li>
                  <NavLink to="/panier" className={({ isActive }) => `cart-link bi bi-cart-fill ${isActive ? "active" : ""}`} onClick={closeMenu}>
                    Panier
                    {totalItems > 0 && (
                      <span className="cart-badge">{totalItems}</span>
                    )}
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
